import React from "react";
import * as Styled from "../stylesView&Create";
import oportunityService from "@services/Oportunity/OportunityService";
import { OportunityContext } from "@context/oportunityContex";
import Spinner from "@components/common/Spinner";
import Button from "@components/common/Button";
import Modal from "@components/Sales/Modal";
import ViewRalationshipComponent from "../Relationship/ViewRalationshipComponent";
import CreateRalationshipComponent from "../Relationship/CreateRalationshipComponent";
import Alert from "@components/common/Alert";
import { LoginContext } from "@context/loginContext";
import { IHashMapKeyString } from "src/@types/Sales";
import { useOnlyMessageToast } from "@hook/useMessageToast";
import { useMessageErrorToast } from "@hook/useMessageErrorToast";
import TableBuyers from "@components/Buyers/TableBuyers";
import { Box, Flex, Text } from "@chakra-ui/react";
import { theme } from "src/styles/theme";

interface IProp {
  indexFirstTab: number;
  navigationCreateAccount: () => void;
  setCpfCnpj: React.Dispatch<React.SetStateAction<string>>;
}

const RelationshipComponent = ({
  indexFirstTab,
  navigationCreateAccount,
  setCpfCnpj,
}: IProp) => {
  const displayMessageSuccess = useOnlyMessageToast();
  const displayMessageError = useMessageErrorToast();
  const { signOut } = React.useContext(LoginContext);
  const {
    faseOp,
    accessCreditRating,
    accessRelationship,
    opportunityIdSalesforce,
    accessCreateOp,
    idRelacionamentoComprador,
    setIdRelacionamentoComprador,
    setLoadingDeleteRelationship,
  } = React.useContext(OportunityContext);
  const [hash, setHash] = React.useState("Relationship");
  const [data, setData] = React.useState<any[]>([]);

  const [account, setAccount] = React.useState("");
  const [accountIdSalesforce, setAccountIdSalesforce] = React.useState("");

  const [successEditRelationship, setSuccessEditRelationship] =
    React.useState(false);
  const [edit, setEdit] = React.useState(false);

  const [isUnauthorized, setIsUnauthorized] = React.useState(false);
  const [loadingRealtionship, setLoadingRealtionship] = React.useState(false);
  const [compradorPrincipal, setCompradorPrincipal] = React.useState(false);
  const [mandatoryCreateAccount, setMandatoryCreateAccount] =
    React.useState(false);

  const [showCreateRelationship, setShowCreateRelationship] =
    React.useState(false);
  const [successCreateRalationship, setSuccessCreateRalationship] =
    React.useState(false);
  const [disabledCreateDocument, setDisabledCreateDocument] =
    React.useState(false);
  const [index, setindex] = React.useState(0);

  const filteredRows = React.useMemo(() => {
    if (!Array.isArray(data)) return [];
    return data;
  }, [data]);

  const handleTypeRelationshipReverse = (typeRelationship: number) => {
    if (typeRelationship === 1) return "Compositor de Renda";
    if (typeRelationship === 2) return "Cônjuge";
    if (typeRelationship === 3) return "Representante Legal";
    if (typeRelationship === 4) return "Fiador";
    if (typeRelationship === 5) return "Comprador Principal";
    return "";
  };

  const handleGetRealtionship = async () => {
    setLoadingRealtionship(true);
    try {
      const response = await oportunityService.getRealtionship({
        OpportunityIdSalesforce:
          opportunityIdSalesforce || accessCreateOp.oportunityIdSalesforce,
      });

      if (response.status >= 400 && response?.status !== 401) {
        setLoadingRealtionship(false);
        setData(Array.isArray(response) ? response : []);
        console.log("status 400", response);
        return;
      }

      if (response.status === 401) {
        setLoadingRealtionship(false);
        setIsUnauthorized(true);
        return;
      }

      setDisabledCreateDocument(response?.[index]?.contaPossuiCPF);
      setData(response);
      setLoadingRealtionship(false);
    } catch (error) {
      setLoadingRealtionship(false);
      console.log("ErrorHandleGetRealtionship", error);
    }
  };

  const handleDeleteRealtionship = async (
    idRelacionamentoComprador: string
  ) => {
    setLoadingRealtionship(true);
    setLoadingDeleteRelationship(true);
    try {
      const response = await oportunityService.deleteRealtionship({
        IdRelacionamentoComprador: idRelacionamentoComprador,
      });

      if (response.status >= 400 && response?.status !== 401) {
        setLoadingRealtionship(false);
        setLoadingDeleteRelationship(false);
        console.log("status 400", response);
        return;
      }

      if (response.status === 401) {
        setLoadingRealtionship(false);
        setLoadingDeleteRelationship(false);
        setIsUnauthorized(true);
        return;
      }

      handleGetRealtionship();
      displayMessageSuccess("Relacionamento deletado com sucesso!");
      setLoadingRealtionship(false);
      setLoadingDeleteRelationship(false);
    } catch (error) {
      setLoadingRealtionship(false);
      setLoadingDeleteRelationship(false);
      console.log("ErrorHandleDeleteRealtionship", error);
    }
  };

  const RelationshipHashMap: IHashMapKeyString = {
    Relationship: (
      <>
        <Flex>
          <Flex flexDir={"column"}>
            <Text fontSize={"18px"} fontWeight={"semibold"}>
              Compradores
            </Text>
            <Text fontSize={"13px"} color={theme.text50}>
              Veja os dados do comprador principal, cônjuge, fiadores e outros
              compositores de renda
            </Text>
          </Flex>

          <Box w={"140px"}>
            <Button
              title={"Novo comprador"}
              onClick={() => setShowCreateRelationship(true)}
              disabled={faseOp}
            />
          </Box>
        </Flex>

        <Styled.ContainerActivityCreditRating>
          <Styled.ContainerRelationship>
            {loadingRealtionship ? (
              <Styled.ContainerRelationshipLoading>
                <Spinner />
              </Styled.ContainerRelationshipLoading>
            ) : (
              <>
                <Styled.ContainerTitleLabelRelationship>
                  {filteredRows?.length === 0 ? (
                    <Styled.ContainerRelationshipEmpty>
                      <span>
                        Não há relacionamento com o comprador nesta
                        oportunidade.
                      </span>
                    </Styled.ContainerRelationshipEmpty>
                  ) : (
                    <>
                      <Styled.ContainerTodoRelationship>
                        <TableBuyers
                          data={filteredRows}
                          handleDeleteRealtionship={handleDeleteRealtionship}
                          setAccount={setAccount}
                          setAccountIdSalesforce={setAccountIdSalesforce}
                          setDisabledCreateDocument={setDisabledCreateDocument}
                          setHash={setHash}
                          setindex={setindex}
                        />
                      </Styled.ContainerTodoRelationship>
                    </>
                  )}
                </Styled.ContainerTitleLabelRelationship>
              </>
            )}
          </Styled.ContainerRelationship>
        </Styled.ContainerActivityCreditRating>
      </>
    ),

    ViewRelationship: (
      <ViewRalationshipComponent
        onBack={() => setHash("Relationship")}
        title={`${accessRelationship.nomeConta} (${accessRelationship.codigoRelacionamentoComComprador})`}
        idRelacionamentoComprador={idRelacionamentoComprador}
        account={account}
        indexRelationship={index}
        isEdit={edit}
        setIsEdit={setEdit}
        setSuccessEditRelationship={setSuccessEditRelationship}
        compradorPrincipal={compradorPrincipal}
        accountIdSalesforce={accountIdSalesforce}
        setAccountIdSalesforce={setAccountIdSalesforce}
        disabledCreateDocument={disabledCreateDocument}
        setCpfCnpj={setCpfCnpj}
      />
    ),
  };

  React.useEffect(() => {
    if (
      indexFirstTab === 1 ||
      successCreateRalationship ||
      successEditRelationship
    ) {
      handleGetRealtionship();
      // handleGetCreditRatingById();
    }
  }, [
    indexFirstTab,
    successCreateRalationship,
    successEditRelationship,
    accessCreditRating,
  ]);

  return (
    <>
      <Alert
        onOpen={isUnauthorized}
        title="Sessão expirada"
        titleButton={"Fazer login novamente"}
        description={
          "Sua sessão expirou, faça login novamente para ter acesso."
        }
        onClick={() => {
          signOut();
        }}
      />

      <Modal
        onOpen={showCreateRelationship}
        title="Criar relacionamento com comprador"
        subtitle="Preencha as informações que serão enviadas para o correspondente bancário realizar a análise de crédito."
        size="4xl"
        onClose={() => {
          if (mandatoryCreateAccount) {
            displayMessageError({
              message: "Necessário criar relacionamento com comprador!",
            });
            return;
          } else {
            setShowCreateRelationship(false);
          }
        }}
      >
        <CreateRalationshipComponent
          accountName={account}
          idRelacionamentoComprador={idRelacionamentoComprador}
          setSuccessCreateRalationship={setSuccessCreateRalationship}
          idAvaliacaoCreditoSalesforce={
            accessCreditRating.idAvaliacaoCreditoSalesforce
          }
          onBack={() => setShowCreateRelationship(false)}
          setIdSuccessCreateRalationship={setIdRelacionamentoComprador}
          navigationCreateAccount={navigationCreateAccount}
          setMandatoryCreateAccount={setMandatoryCreateAccount}
          mandatoryCreateAccount={mandatoryCreateAccount}
          // navigationCreateAccount={() => {}}
        />
      </Modal>

      {RelationshipHashMap[hash]}
    </>
  );
};

export default RelationshipComponent;
